// Club discovery analytics (club_viewed / club_search_results / club_share_opened).
// Fire-and-forget: each helper calls the `logClubEngagement` Cloud Function without
// being awaited and swallows every error, so analytics can never block or break UX.
// Clients cannot write the engagement collection directly; the server validates,
// rate-limits and writes it.
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../config/firebase";
import { MAX_SEARCH_IDS } from "../firebase-functions/schema/clubEngagement";

const logClubEngagementCallable = httpsCallable(functions, "logClubEngagement");

const viewedThisSession = new Set();
let lastSearchQuery = "";

function send(payload) {
  if (!auth.currentUser) return;
  try {
    logClubEngagementCallable(payload).catch((error) => {
      if (__DEV__) console.error("club analytics", error?.message);
    });
  } catch (error) {
    if (__DEV__) console.error("club analytics", error?.message);
  }
}

/** Once per club per app session. */
export function trackClubViewed(clubId, source) {
  if (!clubId || viewedThisSession.has(clubId)) return;
  viewedThisSession.add(clubId);
  send({ type: "club_viewed", clubId, source: source || "unknown" });
}

/**
 * One call per settled search query: results that grow afterwards (Home keeps
 * streaming club pages in) do not re-fire for the same query.
 */
export function trackClubSearchResults(clubIds, query) {
  const ids = (clubIds || []).filter(Boolean).slice(0, MAX_SEARCH_IDS);
  const q = String(query || "").trim().toLowerCase();
  if (ids.length === 0 || !q || q === lastSearchQuery) return;
  lastSearchQuery = q;
  send({ type: "club_search_results", clubIds: ids, source: "search" });
}

export function trackClubShareOpened(clubId) {
  if (!clubId) return;
  send({ type: "club_share_opened", clubId, source: "profile" });
}
